import { Injectable } from '@angular/core';

import { User, AuthenticatedInfo } from './User';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  // Authenticated user subject used to notify those that want to know whether a user
  // has logged in or out.
  private authenticationSubject$: ReplaySubject<AuthenticatedInfo> = new ReplaySubject(1);
  public authenticationInfo$ = this.authenticationSubject$.asObservable();

  public authenticated: boolean = false;
  public USER: User;

  constructor() {
    // See if there might be user details stored somewhere
    let userStored = localStorage.getItem('USER');
    var user = null;
    // See if local storage informatino is valid and that it can be used
    // as a pre-authenticated instance
    if (userStored && userStored.valueOf()) {
      // Set the user that in turn updates the observable
      user = JSON.parse(userStored);
      this.setUser(user);
    }

    // if (JSON.parse(localStorage.getItem('USER')) && JSON.parse(localStorage.getItem('USER').valueOf()))    {
    //   this.USER = JSON.parse(localStorage.getItem('USER'));
    //   this.authenticated = true;
    // }
  }

  isAdmin(): Boolean {
    if (this.USER) {
      return this.USER.roles.includes('ROLE_ADMIN');
    } else {
      return false;
    }
  }

  isUserMan(): Boolean {
    if(this.USER) {
      return this.USER.roles.includes('ROLE_USER_MANAGER')
    } else {
      return false;
    }
  }

  // TODO: Seperate group management from user management
  isGroupMan(): Boolean {
    if(this.USER) {
      return this.USER.roles.includes('ROLE_GROUP_MANAGER')
    } else {
      return false;
    }
  }


  isUser(): Boolean{
    if(this.USER) {
      return this.USER.roles.includes('ROLE_USER')
    } else {
      return false;
    }
  }

  isViewOnly(): Boolean{
    if(this.USER) {
      return this.USER.roles.includes('ROLE_VIEW_ONLY')
    } else {
      return false;
    }
  }

  isConfigUser(): Boolean {
    if(this.USER) {
      return this.USER.roles.includes('ROLE_CONFIG_USER')
    } else {
      return false;
    }
  }

  getUser(): User {
    return this.USER;
  }

  setUser(user: User): void {
    localStorage.removeItem('USER');
    localStorage.setItem('USER', JSON.stringify(user));
    this.USER = user;
    this.authenticated = true;

    // Notify those who are interested that we have a valid user logged in
    this.authenticationSubject$.next({authenticated: true, user: user});
  }

  logout(): void {
    this.authenticated = false;
    localStorage.removeItem('USER');
    // Notify those who are interested that the user logged out
    this.authenticationSubject$.next({authenticated: false, user: null});
  }
}
